import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BFF_URL } from '../environments/environment';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SmsVerificationService {

  constructor(private http: HttpClient) { }

  sendVerificationCode(accountNumber: string): Promise<any> {
    const data = { accountNumber };
    const headers = new HttpHeaders({
      'content-type': 'application/json'
    });
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${BFF_URL}/v1/ca/account/sms-pin`, data, { headers })
        .pipe(take(1))
        .subscribe({
          next: (result) => resolve(result),
          error: (error) => reject(error)
        });
    });
  }

  validateVerificationCode(accountNumber: string, code: string): Promise<any> {
    const data = { accountNumber, temporaryPin: code };
    const headers = new HttpHeaders({
      'content-type': 'application/json'
    });
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${BFF_URL}/v1/ca/account/validate-pin`, data, { headers })
        .pipe(take(1))
        .subscribe({
          next: (result) => resolve(result),
          error: (error) => reject(error)
        });
    });

  }

}
